import { Operator } from '@img-arena/consoles-api-dde'
import type { Column, Filter } from '@/components/table/base'
import { COLUMN_CELL_TYPE } from '@/components/table/base'

export const DDE_TABLE_COLUMNS: Column<Operator>[] = [
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'id',
    label: 'ID',
    sortAttribute: 'id'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'name',
    label: 'Name',
    sortAttribute: 'name'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'email',
    label: 'Email',
    sortAttribute: 'email'
  },
  {
    type: COLUMN_CELL_TYPE.NUMBER,
    id: 'licences',
    label: 'Licenses',
    sortAttribute: 'licences',
    transform: (value) => value?.length || 0
  },
  {
    type: COLUMN_CELL_TYPE.NUMBER,
    id: 'usersCount',
    label: 'Registered Users',
    sortAttribute: 'usersCount'
  },
  {
    type: COLUMN_CELL_TYPE.DATE,
    id: 'createdDate',
    label: 'Created',
    sortAttribute: 'createdDate',
    dateFormat: 'dd-MM-yyyy'
  }
]

export const DDE_TABLE_FILTERS: Filter<Operator>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'ft',
    placeholder: 'Search',
    filterOptions: (row, search) => {
      if (!search) return true

      const lowerCaseSearch = search.toLowerCase()
      const { name, id, email } = row

      return (
        name.toLowerCase().includes(lowerCaseSearch) ||
        String(id).toLowerCase().includes(lowerCaseSearch) ||
        email.toLowerCase().includes(lowerCaseSearch)
      )
    }
  }
]
